<template>
    <!-- 兑换活动管理-兑换订单 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'exchangeGiftGroupOrder')">
            <div slot="header">
                <a-form :form="form" layout="inline" class="store-one-form">
                    <a-form-item label="订单号">
                        <a-input placeholder="请输入" v-decorator="['orderId', {rules:[{pattern: /^[0-9]+$/, message: '所填值必须为数字'}]}]" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="客户名称">
                        <a-input placeholder="请输入" v-decorator="['consumerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="客户类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['consumerType']" @select="search">
                            <a-select-option :value="1">政府</a-select-option>
                            <a-select-option :value="2">企业</a-select-option>
                            <a-select-option :value="3">学校</a-select-option>
                            <a-select-option :value="4">其他</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="销售人员">
                        <a-input placeholder="请输入" v-decorator="['saleMan']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="销售门店">
                        <a-select allowClear placeholder="请选择" v-decorator="['saleShopId']" @select="search">
                            <a-select-option v-for="(item, index) in shopList" :key="index" :value="item.value">{{item.label}}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="销售日期">
                        <a-range-picker
                            style="width:100%"
                            format="YYYY/MM/DD"
                            v-decorator="['saleDate']"
                            @change="search"
                        />
                    </a-form-item>
                    <a-form-item label="销售类型">
                        <a-select allowClear placeholder="请选择" v-decorator="['saleType']" @select="search">
                            <a-select-option :value="2">预付款</a-select-option>
                            <a-select-option :value="1">后付款</a-select-option>
                            <a-select-option :value="0">赠送</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="展示名称">
                        <a-input placeholder="请输入" v-decorator="['goodName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item label="内部标识">
                        <a-input placeholder="请输入" v-decorator="['goodInnerName']" @pressEnter="search"></a-input>
                    </a-form-item>
                    <a-form-item class="wrap-header-button">
                        <a-button :loading="loading" @click="search" class="mr8" type="primary">筛选</a-button>
                        <a-button @click="handleReset">重置</a-button>
                    </a-form-item>
                </a-form>
            </div>
            <a-card title="团购销售订单" :bordered="false">
                <a-button slot="extra" v-if="getBtnByAuth('exchangeGiftGroupOrderExport')" type="primary" @click="toExportOrder">导出</a-button>
                <a-table
                bordered
                :dataSource="dataSource"
                :columns="columns"
                :scroll="{ x: 800}" 
                :pagination="pagination"
                @change="changePage"
                :rowKey="record => record.id"
                >
                <span slot="index" slot-scope="a,b,c">{{c+1}}</span>
                <span slot="goodCategory" slot-scope="goodCategory">{{['','线上票','线下票','优惠券','储值'][goodCategory]}}</span>
                <span slot="saleType" slot-scope="saleType">{{['赠送','后付费','预付费'][saleType]}}</span>
                <span slot="consumerType" slot-scope="consumerType">{{['','政府','企业','学校','其他'][consumerType]}}</span>
                <span slot="saleTotal" slot-scope="a">{{$utils.toFixed(a,2)}}</span>
                <span slot="action" slot-scope="a,row" class="flex">
                    <a class="text-primary" v-if="row.remark == 1 && getBtnByAuth('exchangeGiftGroupOrderDelete')" @click="toComfirmDelete(row.id)">删除</a>
                    <a-divider type="vertical" v-if="row.remark == 1 && (getBtnByAuth('exchangeGiftGroupOrderDelete')&&getBtnByAuth('exchangeGiftGroupOrderDetail'))"></a-divider>
                    <a class="text-primary" v-if="getBtnByAuth('exchangeGiftGroupOrderDetail')" @click="toOrderDetail(row.id)">查看</a>
                </span>
                </a-table>
            </a-card>
        </content-view>
        <a-modal title="删除" centered v-model="isDeleteOrder" @cancel="isDeleteOrder = false; remark = undefined">
            <a-alert message="删除操作，将释放已添加的兑换商品" banner />
            <a-row class="mt16">
                <a-col :span="3"><span class="text-fail">*</span> 备注：</a-col>
                <a-col :span="21"><a-textarea v-model="remark" placeholder="请输入备注" /></a-col>
            </a-row>
            <template slot="footer">
                <a-button @click="isDeleteOrder = false; remark = undefined">
                取消
                </a-button>
                <a-button type="primary" :disabled="!remark" @click="deleteOrderDetail">
                确定
                </a-button>
            </template>
        </a-modal>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex";
    export default {
        name: "exchangeGiftOrder",
        components: {},
        props: {},
        data() {
            const columns = [
                {
                    title: "订单号",
                    dataIndex: "id",
                },
                {
                    title: '客户名称',
                    dataIndex: 'consumerName'
                },
                {
                    title: '客户类型',
                    dataIndex: 'consumerType',
                    scopedSlots: { customRender: "consumerType" }
                },
                {
                    title: '销售类型',
                    dataIndex: 'saleType',
                    scopedSlots: { customRender: "saleType" }
                },
                {
                    title: '商品分类',
                    dataIndex: 'goodCategory',
                    scopedSlots: { customRender: "goodCategory" }
                },
                {
                    title: '销售数量',
                    dataIndex: 'saleNum',
                },
                {
                    title: '订单金额',
                    dataIndex: 'saleTotal',
                    scopedSlots: { customRender: "saleTotal" }
                },
                {
                    title: '销售人员',
                    dataIndex: 'saleMan',
                },
                {
                    title: '销售门店',
                    dataIndex: 'saleShopName',
                    scopedSlots: { customRender: "saleShopName" }
                },
                {
                    title: '销售日期',
                    dataIndex: 'saleDate',
                },
                {
                    title: '操作',
                    width: 100,
                    dataIndex: 'action',
                    scopedSlots: { customRender: "action" }
                },
            ];
            return {
                isDeleteOrder: false,
                remark: undefined,
                cityList: [],
                columns,
                dataSource: [],
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    total: 0,
                    current: 1,
                    pageSize: 20
                },
                loading: false,
                shopList: [],
                deleteId: "",
            };
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        methods: {
            /**
             * @getShopList 获取门店列表
             */
            getShopList() {
                this.$api.totalPlatform.selectList().then(res => {
                    res.forEach((item,index) => {
                        item.label = item.name;
                        item.value = item.id;
                    });
                    this.shopList = [
                        {
                            label: "总部",
                            value: -1,
                        },
                        ...res
                    ];
                    this.getList();
                });
            },
            handleReset() {
                this.form.resetFields();
                this.pagination.current = 1;
                this.pagination.pageSize = 20;
                this.getList();
            },
            search() {
                this.pagination.current = 1;
                this.getList();
            },
            changePage(page) {
                this.pagination.pageSize = page.pageSize;
                this.pagination.current = page.current;
                this.getList();
            },
            toExportOrder() {
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['saleDate'] ? values['saleDate'] : []
                    values.startCreateTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : undefined
                    values.endCreateTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : undefined
                    delete values.validity
                    this.$api.changeCode.exportCouponGroupOrderByCondition({
                    body: Object.assign(values, {
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                        shopId: this.shopId,
                    })
                    },
                    {
                        responseType: "blob"
                    })
                    .then(res => {
                        let a = document.createElement("a");
                        let blob = new Blob([res.data], {
                            // type: "application/vnd.ms-excel"
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });

                        this.downloadUrl = window.URL.createObjectURL(blob);

                        let name = this.$route.meta.name + '-' + this.$moment().format('YYYY/MM/DD') + '.xlsx'

                        a.setAttribute("href", this.downloadUrl);

                        var reportName = decodeURI(name);

                        a.setAttribute("download", reportName);
                        a.click();
                    });
                });
                
            },
            getList() {
                if (!this.shopId) return;
                this.form.validateFields((err, values) => {
                    if (err) return;
                    const validity = values['saleDate'] ? values['saleDate'] : []
                    values.startCreateTime = validity.length > 0 ? validity[0].format('YYYY-MM-DD') : undefined
                    values.endCreateTime = validity.length > 0 ? validity[1].format('YYYY-MM-DD') : undefined
                    delete values.validity
                    this.loading = true;
                    this.$api.changeCode
                    .couponGroupOrder({
                        body: Object.assign(values, {
                            pageNum: this.pagination.current,
                            pageSize: this.pagination.pageSize,
                            shopId: this.shopId,
                        })
                    })
                    .then(res => {
                        this.loading = false;
                        res.list.forEach( el => {
                            let shops = this.shopList.find(shop => shop.value == el.saleShopId);
                            if (shops) {
                                el.saleShopName = shops.label;
                            } else {
                                el.saleShopName = "-";
                            }
                        })
                        this.pagination.total = res.total;
                        this.dataSource = res.list;
                    })
                    .catch(err => {
                        this.loading = false;
                    })
                });
            },
            toOrderDetail(id) {
                this.$router.push({
                    name: "exchangeGroupOrderDetail",
                    query: { orderId: id}
                });
            },
            toComfirmDelete(id) {
                this.isDeleteOrder = true;
                this.deleteId = id;
            },
            deleteOrderDetail() {
                if (!this.remark) {
                    this.$message.warning("请填写备注")
                }
                this.$api.changeCode.deleteOrder({
                    query: {
                        groupId: this.deleteId,
                        remark: this.remark,
                    }
                }).then( res => {
                    this.deleteId = '';
                    this.isDeleteOrder = false; 
                    this.remark = undefined
                    this.$message.success("删除成功");
                    this.getList();
                }).catch(err => {
                    this.getList();
                })
            },
            // 跳转至详情
            toDetail(id) {
                this.$router.push({
                    name: "detailCode",
                    query: { id: id}
                });
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getShopList();
        },
        watch: {
            $route(val) {
                val.name == "changeCodeIndex" && this.getList();
            },
            'shopId'(val) {
                if (!val || !this.shopId) return;
                this.getList()
            }
        }
    };
</script>
<style lang="scss">
</style>